import { createSlice } from "@reduxjs/toolkit";



const initialState = {
    loadingFlag: 0,
    jobDetails: {},
    dropDownJobId: 0,
    errorMessage: '',
    jobId: null,
    backPath: '/joblist',
    dataLoaded: false,
    requestData: {
        claimId: "",
        jobId: "",
        shiftDate: "",
        shiftStartTime: "",
        shiftEndTime: "",
        jobsShiftUniqueId: "",
        save: false,
        shiftType: '',
        viewJobTitle:'',
        occurrenceCorrectionType: ''
    },
    masterData: {
        allShiftStartTime: [],
        allShiftEndTime: [],
        allPreferedShifts: [],
        shiftPreferedLength:[]
    },
    shift: {
        startTime: undefined,
        endTime: undefined,
        preferedShift: undefined,
        date: '',
        endDate: ''
    },
    jobInfo: {
        jobTemplate: {
            name: 'Select'
        },
        jobCategory: undefined,
        jobTitle: undefined,
        jobDescription: '',
        ratePerHour: 0,
        shiftamount: 0,
        billingrate: 0,
        incentive: '',
        total: 0,

    },
    errorLogs: [],
    formdata: [],
    modifyTimeInfo: {
        checkintime: "",
        checkouttime: "",
        shiftstarttime: "",
        shiftendtime: ""
    },
    occurrenceViewVariableRate: {
        occurrenceViewPayRate: [],
        occurrenceViewMileage: []
    },
    jobsShiftsDepartmentsList: [],
    payRateTotalShiftAmount:null,
    payRateType:null,
    isErrorPaymentRate:false,
    workBreakList: []
}

export const viewJobSlice = createSlice({
    name: "viewJobSlice",
    initialState,
    reducers: {
        updateViewJobDetails: (state, { payload: { data } }) => {
            state.jobDetails = data;
            // console.log({ data });
        },
        setJobId: (state, { payload: { claimId, jobId, shiftDate, shiftStartTime, shiftEndTime, jobsShiftUniqueId, save, shiftType, viewJobTitle, occurrenceCorrectionType } }) => {
            state.requestData.claimId = claimId;
            state.requestData.jobId = jobId;
            state.requestData.shiftDate = shiftDate;
            state.requestData.shiftStartTime = shiftStartTime;
            state.requestData.shiftEndTime = shiftEndTime;
            state.requestData.jobsShiftUniqueId = jobsShiftUniqueId;
            state.requestData.save = save;
            state.requestData.shiftType = shiftType
            state.requestData.viewJobTitle = viewJobTitle;
            state.requestData.occurrenceCorrectionType = occurrenceCorrectionType
            // state.requestData = payload;
        },
        setMasterData: (state, action) => {
            state.masterData['allShiftStartTime'] = action.payload?.shiftStartTime;
            state.masterData['allShiftEndTime'] = action.payload?.shiftEndTime;
            state.masterData['allPreferedShifts'] = action.payload?.shiftPreferedTime;
            state.masterData['shiftPreferedLength'] = action.payload?.shiftPreferedLength;
        },
        updateShiftDetails: (state, action) => {
            state.shift[action.payload.field] = action.payload.data;
        },
        setFailureLogs: (state, action) => {
            const errorLogs = [...state.errorLogs, action.payload];
            state.errorLogs = errorLogs;
        },
        loadDataForEdit: (state, action) => {
            const keys = Object.keys(action.payload);
            keys.forEach(key => {
                state[key] = action.payload[key];
            });
        },
        updateJobInfo: (state, action) => {
            state.jobInfo[action.payload.field] = action.payload.data;
        },
        setFormData: (state, action) => {
            state.formdata = action.payload;
        },
        setModifyOccurrence: () => initialState,
        setLoadingFlagIncrement: state => {
            state.loadingFlag = state.loadingFlag + 1
        },
        setLoadingFlagDecrement: state => {
            if (state.loadingFlag !== 0) {
                state.loadingFlag = state.loadingFlag - 1
            }
        },
        setModifyTimeInfo: (state, { payload: { name, value } }) => {
            state.modifyTimeInfo[name] = value;
        },
        setJobDomainId: (state, { payload }) => {
            state.dropDownJobId = payload
        },
        setOccurrenceViewVariableRate: (state, { payload }) => {
            state.occurrenceViewVariableRate[payload?.name] = payload?.value
        },
        setDepartmentList:(state,{payload}) => {
            state.jobsShiftsDepartmentsList = payload
        },
        setPayRateTotalShiftAmount:(state,{payload}) => {
            state.payRateTotalShiftAmount = payload;
        },
        setPayRateType:(state,{payload}) => {
            state.payRateType = payload;
        },
        setIsErrorPaymentRate:(state,{payload}) => {
            state.isErrorPaymentRate = payload;
        },
        setWorkBreakList: (state, {payload}) => {
            state.workBreakList = payload
        }
    }
});


export default viewJobSlice.reducer;
export const { updateViewJobDetails, setJobId, setMasterData,
    updateShiftDetails, setFailureLogs, loadDataForEdit, updateJobInfo, setFormData, setModifyOccurrence, setLoadingFlagIncrement, setLoadingFlagDecrement, setModifyTimeInfo, setOccurrenceViewVariableRate, setJobDomainId,setDepartmentList,setPayRateTotalShiftAmount,setPayRateType ,setIsErrorPaymentRate, setWorkBreakList} = viewJobSlice.actions;